import React from "react";
import { Link } from "react-router-dom";
import GeneralFAQs from "../section/GeneralFAQs";
import PricingFAQs from "../section/PricingFAQs";
import ProtectionFAQs from "../section/ProtectionFAQs";
import DuringFAQs from "../section/DuringFAQs";
export default function FAQ() {



    return (
        <>
            <section className="landingpages">
                <div className="container h-[75%] flex flex-col gap-[5px] items-center justify-center">
                    <div className="text-white font-bold capitalize text-[40px] btmAni2000">FAQs</div>
                    <div className="flex items-center text-[20px] gap-[4px] text-white btmAni25002">
                        <Link className="text-white" to={"/"}>Home</Link>
                        -
                        <span className="text-white">FAQs</span>
                    </div>
                </div>
            </section>
            <section>
                <div className="container flex flex-col gap-[40px]">
                   <GeneralFAQs/>
                   <PricingFAQs/>
                   <ProtectionFAQs/>
                   <DuringFAQs/>
                </div>
            </section>
        </>
    );
}